<template>
  <div>
    <div v-if="!loading">
      <!-- Brand Comparison Cards -->
      <div class="brand-cards-container mb-4">
        <div v-for="brand in selectTopMetrics" :key="brand._id" class="brand-card-wrapper">
          <TopMetricsCard :brand="brand" />
        </div>
      </div>

      <CompetitionHeatmap />
    </div>

    <!-- loader -->
    <div v-else>
      <div class="row">
        <div class="col col-12 mb-3">
          <b-skeleton style="width: 100%" height="289px" v-for="i of 3" :key="i" class="mb-3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopMetricsCard from '../UI/TopMetricsCard'
import CompetitionHeatmap from '../UI/CompetitionHeatmap'
import { createNamespacedHelpers } from 'vuex'

const CompetitionModule = createNamespacedHelpers('competition')

export default {
  name: 'CompetitionSummary',
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  components: {
    TopMetricsCard,
    CompetitionHeatmap
  },
  computed: {
    ...CompetitionModule.mapGetters(['selectTopMetrics'])
  }
}
</script>

<style scoped>
.brand-cards-container {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  margin-bottom: 1rem;
}

/* Extra small screens (xs) - 1 card per row */
@media (max-width: 575.98px) {
  .brand-cards-container {
    grid-template-columns: 1fr;
  }
}

/* Small screens (sm) - 2 cards per row */
@media (min-width: 576px) and (max-width: 767.98px) {
  .brand-cards-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Medium screens (md) - 3 cards per row */
@media (min-width: 768px) and (max-width: 991.98px) {
  .brand-cards-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Large screens (lg) - 4 cards per row */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .brand-cards-container {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* Extra large screens (xl) - 5 cards per row */
@media (min-width: 1200px) {
  .brand-cards-container {
    grid-template-columns: repeat(5, 1fr);
  }
}

/* 2xl screens - 6 cards per row */
@media (min-width: 1600px) {
  .brand-cards-container {
    grid-template-columns: repeat(6, 1fr);
  }
}

.brand-card-wrapper {
  /* No additional styles needed - grid handles everything */
}
</style>
